import React from 'react';
import clsx from 'clsx';
import { Image, T } from '@colonist/ui';
import styles from './AccountInfo.module.scss';
export const AccountInfo = ({ image, title, email, isConnected, size })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.account, size == 'sm' && styles.narrow)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.iconBox
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: image
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.accountInfo
    }, /*#__PURE__*/ React.createElement("h3", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), isConnected && email != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.email
    }, email)));
